import React, { useContext, useState } from "react"
import moment from "moment-timezone"
import DateTimePicker from "./DateTimePicker"
import Form from "./Form"
import UserImage from "./UserImage"
import isEmail from "validator/lib/isEmail"
import ProgressDots from "../../../components/ProgressDots"
import { isValidPhone } from "../../PhoneNumber"
import { SpaceProfileContext } from "../context"
import "./styles.less"
import submitBookTour from "../../../utils/submitBookTour"

export default ({
  space = {},
  calendar = {},
  locationsUuid = "",
  isInline = false,
}) => {
  const {
    commonData: { contextDate, contextTime, bookTourStep, bookTour },
    actions: { setBookTourStep, setBookTour, setValue },
  } = useContext(SpaceProfileContext)

  const [name, setName] = useState("")
  const [email, setEmail] = useState("")
  const [phone, setPhone] = useState("")
  const [message, setMessage] = useState("")
  const [marketingEmails, setMarketingEmails] = useState(true)

  const [formSubmitted, setFormSubmitted] = useState(false)
  const [progress, setProgress] = useState(false)

  const resetForm = () => {
    if (bookTourStep === 4) {
      return
    }
    setBookTourStep(1)
    setName("")
    setEmail("")
    setMessage("")
  }

  const handleBgClick = () => {
    if (typeof window !== undefined && window.innerWidth > 1200) {
      setBookTour(false)
      resetForm()
    }
  }

  const closeModal = () => {
    setBookTour(false)
    resetForm()
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setProgress(true)

    const res = await submitBookTour({
      user: { name, phone, email, message },
      locationsUuid,
      space,
      contextDate,
      contextTime,
      calendar: calendar.calendar,
      marketingEmails,
    })

    setValue({ bookTourComplete: true })
    setFormSubmitted(true)
    setProgress(false)
  }

  const onBack = () => {
    // setContextDate(moment().format("YYYY-MM-DD"))
    // setContextTime("")
    setBookTourStep(bookTourStep - 1)
  }

  return (
    <div className={isInline ? "container" : ""}>
      <div
        className={`workplace-one-modal book-a-tour ${bookTour ? "show" : ""} ${
          isInline ? "inline-module bottom-line" : ""
        }`}
        onClick={handleBgClick}
      >
        <div
          className={`modal-content ${isInline ? "d-none d-lg-block" : ""}`}
          onClick={(e) => e.stopPropagation()}
        >
          {!isInline && (
            <img
              src={require("../../../images/close.svg").default}
              className={"modal-close"}
              alt="Close"
              onClick={closeModal}
            />
          )}

          <div className="modal-inner">
            <div className={`form-message ${formSubmitted ? "show" : ""}`}>
              <UserImage space={space} />
              <h5>Confirmed</h5>
              <p className="title-sub">
                You are scheduled with {space.contact_name}.
              </p>
              <ul className="tour-summary">
                <li>{calendar.calendar.duration} minute call</li>
                <li>
                  {contextTime},{" "}
                  {moment(contextDate).format("dddd, MMMM DD, YYYY")}
                </li>
                {space.office_address && (
                  <li>{space.office_address.short_address}</li>
                )}
              </ul>
            </div>

            <div className={`form-body ${formSubmitted ? "hidden" : ""}`}>
              {bookTourStep <= 2 && (
                <DateTimePicker space={space} calendar={calendar} />
              )}
              {bookTourStep === 3 && (
                <Form
                  step={bookTourStep}
                  space={space}
                  name={name}
                  setName={setName}
                  email={email}
                  setEmail={setEmail}
                  message={message}
                  setMessage={setMessage}
                  phone={phone}
                  setPhone={setPhone}
                  marketingEmails={marketingEmails}
                  setMarketingEmails={setMarketingEmails}
                />
              )}
            </div>
          </div>

          {!formSubmitted && bookTourStep === 3 && (
            <div className={"book-buttons"}>
              <button onClick={onBack} className={`btn btn-link `}>
                Back
              </button>
              <button
                onClick={handleSubmit}
                className={`btn btn-primary submit_schedule_call ${
                  progress ? "submitting" : ""
                }`}
                disabled={
                  !name ||
                  !email ||
                  !isEmail(email) ||
                  progress ||
                  !isValidPhone(phone, true)
                }
              >
                <ProgressDots active={progress} />
                Schedule Call
              </button>
            </div>
          )}
          {formSubmitted && !isInline && (
            <div className="book-buttons justify-content-end">
              <button
                onClick={closeModal}
                className={"btn btn-primary close-button"}
              >
                Close
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
